module.exports = __webpack_public_path__ + "img/sos-type-blue.a480f899.png";